( function () {
	'use strict';

	function visualizeService ( logger, visualize ) {
		function login () {
			var config = {
				'auth' : {
					'name'         : 'jasperadmin',
					'password'     : 'jasperadmin',
					'organization' : 'sinet'
				}
			};

			visualize().config( config );

			visualize()( function ( v ) {
				v.login( config );
			} );
		}

		function logout () {
			visualize()( function ( v ) {
				v.logout();
			} );
		}

		function handleError ( err ) {
			logger.notifyError( 'Error rendering report : ' + err, 'Report' );
		}

		function loadReports ( scope, element ) {
			visualize()( function ( v ) {
				v( '#' + element[ 0 ].id )
					.report( {
						'resource'  : scope.resource,
						'container' : '#visualize-container',
						'params'    : scope.params,
						'error'     : handleError
					} );
			} );
		}

		return {
			'loadReports' : loadReports,
			'login'       : login,
			'logout'      : logout
		};
	}

	angular
		.module( 'app.report' )
		.factory( 'visualizeService', visualizeService );

	visualizeService.$inject = [ 'logger', 'visualize' ];
} )();
